import EditOutlined from '../../../../assets/images/config-edit.svg';
const rowStyle = { margin: 0, padding: "5px 0" };

export const CONFIG_COLUMNS = ({ actionRender }) => [
    {
        title: "SNo",
        width: 60,
        align: "center",
        render: (_, detail, index) => <>{index + 1}</>
    },
    {
        title: "Config ID",
        width: 200,
        dataIndex: "configId",
        key: "configId",
        render: (text) => text || "Nil"
    },
    {
        title: "Default Value",
        width: 200,
        dataIndex: "defaultValue",
        key: "defaultValue",
        ellipsis: true,
        render: (text) => text || "Nil"
    },
    {
        title: "Config Values",
        width: 300,
        dataIndex: "configuration",
        key: "configuration",
        ellipsis: true,
        render: (configuration) => {
            if (Array.isArray(configuration)) {
                return configuration.join(", ") || "Nil";
            }
            return configuration || "Nil";
        }
    },
    {
        title: "Config Type",
        width: 120,
        dataIndex: "configType",
        key: "configType",
        render: (text) => text || "Nil"
    },
    {
        title: "Action",
        width: 100,
        align: "center",
        render: (text, record) => (
            <div
                style={{ cursor: 'pointer', textAlign: 'start', ...rowStyle }}
                onClick={(event) => {
                    event?.preventDefault();
                    event?.stopPropagation();
                    actionRender(record);
                }}
            >
                <img src={EditOutlined} alt="edit" style={{ width: "16px", height: "16px", marginLeft: "8px" }} />
            </div>
        )
    }
];
